import React, { useEffect, useState } from 'react'
import { Box, Typography,InputAdornment } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import InputBox from '../../Components/InputBox/InputBox'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import {
    ButtonCmp,
    InputCmp,
    DropDownCmp,
    WhiteButtonCmp,
    TextAreaCmp,
} from '..'
import { useForm } from 'react-hook-form'
import styles from './ProfileForms.module.css'
import { UpdateProfileAction } from '../../Store/Actions/ProfileAction'
import useAlert from '../../Hooks/useAlert/useAlert'
import { GetStateAction, GetLicensedServicesAction, GetOtherServicesAction } from '../../Store/Actions/GetActions'
import { yupResolver } from '@hookform/resolvers/yup'
import { validation } from '../../Config'
const DocsAndRegForm = ({ handleCancel, profileDetailsdata }) => {
    const {
        licensed_profession,
        licensed_service_id,
        licensed_number,
        fein_corporate_charter_no,
        bonded,
        general_liability_insurance,
        gli_policy,
        gli_max,
        worker_comp,
        wc_policy,
        wc_max,
        business_description,
        affiliations,
        certifications,
        state,
        state_id
    } = profileDetailsdata

    ///=>>>gli = general Liability Insurance
    const [gliStatus, setGliStatus] = useState(true)
    const [workersComp, setWorkersComp] = useState(true)

    const { setAlert } = useAlert()
    const dispatch = useDispatch()
    const docAndRegistrationValidation = validation.docAndRegistrationValidation
    // const [servicesArr, setServicesArr] = useState(profileDetailsdata?.services_licensed?.map((i) => i.service) || [])
    const [otherServicesArr, setOtherServicesArr] = useState(profileDetailsdata?.services_other?.map((i) => i.service) || [])
    const { licensedServicesdata } = useSelector((state) => state.LicensedServicesReducer)
    const { otherServicesdata } = useSelector((state) => state.OtherServicesReducer)

    const { control, handleSubmit, watch, setValue } = useForm({
        mode: 'onChange',
        defaultValues: {
            licensedProfession: '', // Start with empty, will be set in useEffect
            licenseNumber: licensed_number || '',
            FEIN: fein_corporate_charter_no || '',
            bonded: bonded ? 'YES' : 'NO',
            generalLiabilityInsurance: general_liability_insurance
                ? 'YES'
                : 'NO',
            gliPolicy: gli_policy || null,
            gliPolicyMax: gli_max || '',
            workersComp: worker_comp ? 'YES' : 'NO',
            wcPolicy: wc_policy || null,
            wcPolicyMax: wc_max || '',
            businessDescription: business_description || '',
            affiliations: affiliations || '',
            multiStates: state,
            // licensedService: '',
            otherService: '',
        },
        resolver: yupResolver(docAndRegistrationValidation)
    })

    // Watch the licensedProfession field
    const licensedProfessionState = watch('licensedProfession')

    const gliState = watch('generalLiabilityInsurance')
    const workersCompState = watch('workersComp')
    // const licensedServiceState = watch('licensedService')
    const otherServiceState = watch('otherService')

    useEffect(() => {
        if (gliState) {
            console.log('gliState', gliState)
            if (gliState === 'NO') {
                setGliStatus(true)
                setValue('gliPolicy', null)
                setValue('gliPolicyMax', '')
            } else {
                setGliStatus(false)
            }
        }
    }, [gliState])

    useEffect(() => {
        if (workersCompState) {
            if (workersCompState === 'NO') {
                setWorkersComp(true)
                setValue('wcPolicy', null)
                setValue('wcPolicyMax', '')
            } else {
                setWorkersComp(false)
            }
        }
    }, [workersCompState])

    useEffect(() => {
        dispatch(GetStateAction())
        dispatch(GetLicensedServicesAction())
        dispatch(GetOtherServicesAction())
    }, [])

    // Set the licensedProfession value when licensedServicesdata is loaded and licensed_service_id exists
    useEffect(() => {
        if (licensedServicesdata && licensed_service_id && licensed_service_id != 0) {
            // Find the service object that matches the licensed_service_id
            const selectedService = licensedServicesdata.find(service => service.id == licensed_service_id)
            if (selectedService) {
                setValue('licensedProfession', selectedService)
            }
        }
    }, [licensedServicesdata, licensed_service_id, setValue])

    const { statesdata, statesLoading } = useSelector(
        (state) => state.StatesReducers
    )

    // useEffect(() => {
    //     if (licensedServiceState) {
    //         const alreadyExist = servicesArr.find((i) => i.slug === licensedServiceState.slug)
    //         if (alreadyExist) {
    //             setAlert('This service already exist', 'error')
    //             setValue('licensedService', '')
    //             return
    //         }
    //         setServicesArr([...servicesArr, licensedServiceState])
    //         setValue('licensedService', '')
    //     }
    // }, [licensedServiceState])

    useEffect(() => {
        if (otherServiceState) {
            const alreadyExist = otherServicesArr.find((i) => i.slug === otherServiceState.slug)
            if (alreadyExist) {
                setAlert('This service already exist', 'error')
                setValue('otherService', '')
                return
            }
            setOtherServicesArr([...otherServicesArr, otherServiceState])
            setValue('otherService', '')
        }
    }, [otherServiceState])

    const removeService = (ind, whichService) => {
        // if (whichService === 'licensedService') {
        //     servicesArr.splice(ind, 1)
        //     setServicesArr([...servicesArr])
        // } else {
            otherServicesArr.splice(ind, 1)
            setOtherServicesArr([...otherServicesArr])
        // }
    }

    const onSubmit = (obj) => {
        const objToSend = {
            ...obj,
            licensedProfession: obj.licensedProfession,
            services_other: otherServicesArr,
        }
        dispatch(UpdateProfileAction(objToSend, 'documentAndRegistration', setAlert))
    }

    return (
        <section className={styles.profile_doc_reg}>
            <div className={styles.profile_information_heading}>
                <Typography noWrap variant="h5" fontWeight={'bold'}>
                    Documents and Registrations
                </Typography>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className={styles.detailsBoxes}>
                    <section>
                        <DropDownCmp
                            name="licensedProfession" //imporant
                            control={control} //imporant
                            label="Licensed Profession"
                            options={
                                licensedServicesdata && licensedServicesdata
                            }
                            disableClearable
                            freeSolo={false}
                            required
                        />
                    </section>
                    <section>
                        <InputCmp
                            name="licenseNumber" //imporant
                            control={control} //imporant
                            label="License Number #1"
                        />
                    </section>
                    <section>
                        {/* <InputCmp
            name="licenseNumber" //imporant
            control={control} //imporant
            label="Select States"
          /> */}
                        <DropDownCmp
                            control={control}
                            name="multiStates"
                            label={'State'}
                            options={statesdata && statesdata}
                            // multiple={true}

                            // disableClearable
                            // freeSolo={false}
                        />
                    </section>
                    <section>
                        <InputCmp
                            name="FEIN" //imporant
                            control={control} //imporant
                            label=" #, Corporate #, Charter #, or ASID #"
                        />
                    </section>
                </div>
                {/* <div className={styles.detailsBoxes}>
                    <section>
                        <DropDownCmp
                            name="bonded" //imporant
                            control={control} //imporant
                            label="Insured"
                            options={['YES', 'NO']}
                            disableClearable
                            freeSolo={false}
                            required
                        />
                    </section>
                    <section>
                        <DropDownCmp
                            name="generalLiabilityInsurance" //imporant
                            control={control} //imporant
                            label="General Liability Insurance"
                            options={['YES', 'NO']}
                            disableClearable
                            freeSolo={false}
                            required
                        />

                        <Box sx={{ mt: '15px' }}>
                            <InputCmp
                                name="gliPolicy" //imporant
                                control={control} //imporant
                                label="Policy #"
                                disabled={gliStatus}
                            />
                        </Box>

                        <Box sx={{ mt: '15px' }}>
                            <InputCmp
                                name="gliPolicyMax" //imporant
                                control={control} //imporant
                                label="Policy Maximum"
                                disabled={gliStatus}
                                type="number"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            $
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Box>
                    </section>
                    <section>
                        <DropDownCmp
                            name="workersComp" //imporant
                            control={control} //imporant
                            label="Worker's Comp?"
                            options={['YES', 'NO']}
                            disableClearable
                            freeSolo={false}
                            required
                        />

                        <Box sx={{ mt: '15px' }}>
                            <InputCmp
                                name="wcPolicy" //imporant
                                control={control} //imporant
                                label="Policy #"
                                disabled={workersComp}
                            />
                        </Box>

                        <Box sx={{ mt: '15px' }}>
                            <InputCmp
                                name="wcPolicyMax" //imporant
                                control={control} //imporant
                                label="Policy Maximum"
                                disabled={workersComp}
                                type="number"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            $
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Box>
                    </section>
                </div> */}
                <div className={styles.detailsBoxes}>
                    <section>
                        <TextAreaCmp
                            control={control}
                            name="businessDescription"
                            label="Company Bio"
                            rows={5}
                        />
                    </section>
                </div>

                <section style={{ width: '50%' }}>
                    <Typography noWrap variant="h6" fontWeight={'600'}>
                        Other Service
                    </Typography>
                    <Box sx={{ my: '20px' }}>
                        <DropDownCmp
                            name="otherService"
                            control={control}
                            label="Select Other Services"
                            options={otherServicesdata ? otherServicesdata : []}
                            disableClearable
                            freeSolo={false}
                        />
                    </Box>
                    <Box
                        sx={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}
                    >
                        {otherServicesArr.length > 0 &&
                            otherServicesArr.map((service, ind) => (
                                <div key={ind} className={styles.scrollTabsBar}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '5px',
                                        }}
                                    >
                                        {service.label}
                                    </Box>
                                    <Box>
                                        <span
                                            style={{
                                                cursor: 'pointer',
                                                marginLeft: 4,
                                                color: 'red',
                                            }}
                                            onClick={() =>
                                                removeService(
                                                    ind,
                                                    'otherServicesArr'
                                                )
                                            }
                                        >
                                            x
                                        </span>
                                    </Box>
                                </div>
                            ))}
                    </Box>
                </section>

                <div className={styles.buttonContainer}>
                    <WhiteButtonCmp
                        title="Cancel"
                        onClick={() => handleCancel('documentsInfo')}
                    />

                    <ButtonCmp
                        title="Save"
                        style={{ marginLeft: '10px' }}
                        type="submit"
                    />
                </div>
            </form>
        </section>
    )
}

export default DocsAndRegForm
